import { KeyboardEvent, MouseEvent, useEffect, useRef } from "react"
import Actionbar from "src/components/common/actionbar/Authactionbar"
import { Message } from "src/components/common/form/Message"
import useUiuxStore from "src/store/useUiuxStore"
import { Content_SYS3010_R01 } from "./Content_SYS3010_R01"
import { SYS3010_R01Dto } from "./Dto_SYS3010_R01"
import { SearchSection_SYS3010_R01 } from "./SearchSection_SYS3010_R01"
import { useSYS3010_R01Store } from "./Store_SYS3010_R01"
import { Table_SYS3010_R01 } from "./Table_SYS3010_R01"
import { AgGridReact } from "ag-grid-react"

/**
 * 사용자 관리 컨테이너 컴포넌트
 * 사용자 관리 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_SYS3010_R01 = () => {
	
	const { 
		SYS3010_R01List,
	} = useSYS3010_R01Store();
	const { setMessage } = useUiuxStore();
	const gridRef = useRef<AgGridReact<SYS3010_R01Dto> | null>(null);

	


	// UserContent에서 필요한 핸들러 함수들을 가져옴
	const {
		clickable, setClickable,
		buttonDisabled,
		handleExcelClick,
		handleUserNmChange,
		defaultSYS3010_R01Row,
		fetchData,
		initContainerData,
		handleInsertClick,
		handleSaveClick,
		handleDeleteClick,
	} = Content_SYS3010_R01({
		gridRef,
		setMessage,
		
	});

	useEffect(() => { 
		if (SYS3010_R01List.length === 0) { handleInsertClick({} as MouseEvent<HTMLButtonElement>); }
	}, [SYS3010_R01List, handleInsertClick]);

	return <div className="content-container">
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleInsertClick}
			onSaveClick={handleSaveClick}
			onDeleteClick={handleDeleteClick}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		
		<SearchSection_SYS3010_R01
			onUserNmChange={handleUserNmChange}
			onEnterKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
				if (e.key === 'Enter') {
					fetchData()
				}
			}} 
		/>
		<div className="flex-1 flex">
			<div className="w-full h-full flex flex-col  p-[12px] gap-[12px]">
				
				<Table_SYS3010_R01
					clickable={clickable}				setClickable={setClickable}
					gridRef={gridRef}
					defaultSYS3010_R01Row={defaultSYS3010_R01Row()}
				/>
			</div>
		</div>
		{/* 메시지 표시 컴포넌트 */}
		<Message />
	</div>
}